import PatientNotes from './PatientNotes';

export default PatientNotes;
